<template>
  <portal-invoice-payment
    :invoice="invoice"
    @invoice-updated="invoice = $event"
  />
</template>
<script>
import PortalInvoicePayment from "../../ClientPortal/components/invoice_payment/PortalInvoicePayment.vue"

export default {
  name: "PortalPayment",

  components: {
    PortalInvoicePayment,
  },

  data() {
    return {
      invoice: window.FinancialCents.invoice,
    }
  },
}
</script>
